import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAxP1qeH_Xz0PvhaVnjkZH9x-mziSuHP9E",
  authDomain: "italy2026-75596.firebaseapp.com",
  projectId: "italy2026-75596",
  storageBucket: "italy2026-75596.firebasestorage.app",
  messagingSenderId: "345977317883",
  appId: "1:345977317883:web:acbb23a626b696e710c35e",
  measurementId: "G-M5WPGS6NHF"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
